import React from 'react'

import PSPelaksanaanPraktikKinerjaPage from 'app/KinerjaPSPegawaiPage/pages/Pelaksanaan/PraktikKinerja/Beranda'
import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import PageGuardPSPegawai from 'app/KinerjaPSPegawaiPage/components/PageGuardPSPegawai'

import type { PageProps } from 'app/KinerjaShared/components/KinerjaLayout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled = toggle?.['kinerja-ps-enabled'] || false
    const enabledAsPegawai = toggle?.['kinerja-ps-pegawai-enabled'] || false

    if (!enabled || !enabledAsPegawai) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }
  },
})

const Page = (_props: PageProps) => {
  return (
    <PageGuardPSPegawai>
      <PSPelaksanaanPraktikKinerjaPage />
    </PageGuardPSPegawai>
  )
}

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
  pageTitle: 'Pengelolaan Kinerja',
}

export default Page
